export const GET_KMS_DOCUMENTS_BY_REPERTOIRE_REQUEST = "GET_KMS_DOCUMENTS_BY_REPERTOIRE_REQUEST";
export const GET_KMS_DOCUMENTS_BY_REPERTOIRE_SUCCESS = "GET_KMS_DOCUMENTS_BY_REPERTOIRE_SUCCESS";
export const GET_KMS_DOCUMENTS_BY_REPERTOIRE_FAIL = "GET_KMS_DOCUMENTS_BY_REPERTOIRE_FAIL";

export const GET_KMS_DOCUMENTS_REQUEST = "GET_KMS_DOCUMENTS_REQUEST";
export const GET_KMS_DOCUMENTS_SUCCESS = "GET_KMS_DOCUMENTS_SUCCESS";
export const GET_KMS_DOCUMENTS_FAIL = "GET_KMS_DOCUMENTS_FAIL";
export const GET_KMS_ARCHIVED_DOCUMENTS_REQUEST = "GET_KMS_ARCHIVED_DOCUMENTS_REQUEST";
export const GET_KMS_ARCHIVED_DOCUMENTS_SUCCESS = "GET_KMS_ARCHIVED_DOCUMENTS_SUCCESS";
export const GET_KMS_ARCHIVED_DOCUMENTS_FAIL = "GET_KMS_ARCHIVED_DOCUMENTS_FAIL";
export const GET_KMS_TRASHED_DOCUMENTS_REQUEST = "GET_KMS_TRASHED_DOCUMENTS_REQUEST";
export const GET_KMS_TRASHED_DOCUMENTS_SUCCESS = "GET_KMS_TRASHED_DOCUMENTS_SUCCESS";
export const GET_KMS_TRASHED_DOCUMENTS_FAIL = "GET_KMS_TRASHED_DOCUMENTS_FAIL";

export const GET_KMS_DOCUMENTS_BY_CONTENT_REQUEST = "GET_KMS_DOCUMENTS_BY_CONTENT_REQUEST";
export const GET_KMS_DOCUMENTS_BY_CONTENT_SUCCESS = "GET_KMS_DOCUMENTS_BY_CONTENT_SUCCESS";
export const GET_KMS_DOCUMENTS_BY_CONTENT_FAIL = "GET_KMS_DOCUMENTS_BY_CONTENT_FAIL";

export const GET_KMS_DOCUMENT_REQUEST = "GET_KMS_DOCUMENT_REQUEST";
export const GET_KMS_DOCUMENT_SUCCESS = "GET_KMS_DOCUMENT_SUCCESS";
export const GET_KMS_DOCUMENT_FAIL = "GET_KMS_DOCUMENT_FAIL";

export const UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_REQUEST = "UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_REQUEST";
export const UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_SUCCESS = "UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_SUCCESS";
export const UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_FAIL = "UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_FAIL";

export const UPLOAD_KMS_DOCUMENT_TO_CONTENT_REQUEST = "UPLOAD_KMS_DOCUMENT_TO_CONTENT_REQUEST";
export const UPLOAD_KMS_DOCUMENT_TO_CONTENT_SUCCESS = "UPLOAD_KMS_DOCUMENT_TO_CONTENT_SUCCESS";
export const UPLOAD_KMS_DOCUMENT_TO_CONTENT_FAIL = "UPLOAD_KMS_DOCUMENT_TO_CONTENT_FAIL";
export const UPDATE_KMS_DOCUMENT_REQUEST = "UPDATE_KMS_DOCUMENT_REQUEST";
export const UPDATE_KMS_DOCUMENT_SUCCESS = "UPDATE_KMS_DOCUMENT_SUCCESS";
export const UPDATE_KMS_DOCUMENT_FAIL = "UPDATE_KMS_DOCUMENT_FAIL";

export const CHANGE_KMS_DOCUMENT_STATUS_SUCCESS = "CHANGE_KMS_DOCUMENT_STATUS_SUCCESS";
export const CHANGE_KMS_DOCUMENT_STATUS_FAIL = "CHANGE_KMS_DOCUMENT_STATUS_FAIL";
export const SUBMIT_KMS_DOCUMENT_REQUEST = "SUBMIT_KMS_DOCUMENT_REQUEST";
export const APPROVE_KMS_DOCUMENT_REQUEST = "APPROVE_KMS_DOCUMENT_REQUEST";
export const REJECT_KMS_DOCUMENT_REQUEST = "REJECT_KMS_DOCUMENT_REQUEST";
export const RETURN_KMS_DOCUMENT_TO_DRAFT_REQUEST = "RETURN_KMS_DOCUMENT_TO_DRAFT_REQUEST";
export const PUBLISH_KMS_DOCUMENT_REQUEST = "PUBLISH_KMS_DOCUMENT_REQUEST";
export const ARCHIVE_KMS_DOCUMENT_REQUEST = "ARCHIVE_KMS_DOCUMENT_REQUEST";
export const ARCHIVE_KMS_DOCUMENT_FAIL = "ARCHIVE_KMS_DOCUMENT_FAIL";

export const GET_KMS_DOCUMENT_COMMENTS_REQUEST = "GET_KMS_DOCUMENT_COMMENTS_REQUEST";
export const GET_KMS_DOCUMENT_COMMENTS_SUCCESS = "GET_KMS_DOCUMENT_COMMENTS_SUCCESS";
export const GET_KMS_DOCUMENT_COMMENTS_FAIL = "GET_KMS_DOCUMENT_COMMENTS_FAIL";
export const GET_KMS_DOCUMENT_SUBSCRIPTION_REQUEST = "GET_KMS_DOCUMENT_SUBSCRIPTION_REQUEST";
export const GET_KMS_DOCUMENT_SUBSCRIPTION_SUCCESS = "GET_KMS_DOCUMENT_SUBSCRIPTION_SUCCESS";
export const GET_KMS_DOCUMENT_SUBSCRIPTION_FAIL = "GET_KMS_DOCUMENT_SUBSCRIPTION_FAIL";
export const GET_KMS_DOCUMENT_RATING_SUMMARY_REQUEST = "GET_KMS_DOCUMENT_RATING_SUMMARY_REQUEST";
export const GET_KMS_DOCUMENT_RATING_SUMMARY_SUCCESS = "GET_KMS_DOCUMENT_RATING_SUMMARY_SUCCESS";
export const GET_KMS_DOCUMENT_RATING_SUMMARY_FAIL = "GET_KMS_DOCUMENT_RATING_SUMMARY_FAIL";
export const CREATE_KMS_DOCUMENT_COMMENT_REQUEST = "CREATE_KMS_DOCUMENT_COMMENT_REQUEST";
export const CREATE_KMS_DOCUMENT_COMMENT_SUCCESS = "CREATE_KMS_DOCUMENT_COMMENT_SUCCESS";
export const CREATE_KMS_DOCUMENT_COMMENT_FAIL = "CREATE_KMS_DOCUMENT_COMMENT_FAIL";
export const DELETE_KMS_DOCUMENT_COMMENT_REQUEST = "DELETE_KMS_DOCUMENT_COMMENT_REQUEST";
export const DELETE_KMS_DOCUMENT_COMMENT_SUCCESS = "DELETE_KMS_DOCUMENT_COMMENT_SUCCESS";
export const DELETE_KMS_DOCUMENT_COMMENT_FAIL = "DELETE_KMS_DOCUMENT_COMMENT_FAIL";
export const SUBSCRIBE_KMS_DOCUMENT_REQUEST = "SUBSCRIBE_KMS_DOCUMENT_REQUEST";
export const SUBSCRIBE_KMS_DOCUMENT_SUCCESS = "SUBSCRIBE_KMS_DOCUMENT_SUCCESS";
export const SUBSCRIBE_KMS_DOCUMENT_FAIL = "SUBSCRIBE_KMS_DOCUMENT_FAIL";
export const UNSUBSCRIBE_KMS_DOCUMENT_REQUEST = "UNSUBSCRIBE_KMS_DOCUMENT_REQUEST";
export const UNSUBSCRIBE_KMS_DOCUMENT_SUCCESS = "UNSUBSCRIBE_KMS_DOCUMENT_SUCCESS";
export const UNSUBSCRIBE_KMS_DOCUMENT_FAIL = "UNSUBSCRIBE_KMS_DOCUMENT_FAIL";
export const UPSERT_KMS_DOCUMENT_RATING_REQUEST = "UPSERT_KMS_DOCUMENT_RATING_REQUEST";
export const UPSERT_KMS_DOCUMENT_RATING_SUCCESS = "UPSERT_KMS_DOCUMENT_RATING_SUCCESS";
export const UPSERT_KMS_DOCUMENT_RATING_FAIL = "UPSERT_KMS_DOCUMENT_RATING_FAIL";

export const DELETE_KMS_DOCUMENT_REQUEST = "DELETE_KMS_DOCUMENT_REQUEST";
export const DELETE_KMS_DOCUMENT_SUCCESS = "DELETE_KMS_DOCUMENT_SUCCESS";
export const DELETE_KMS_DOCUMENT_FAIL = "DELETE_KMS_DOCUMENT_FAIL";
export const RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_REQUEST = "RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_REQUEST";
export const RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_SUCCESS = "RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_SUCCESS";
export const RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_FAIL = "RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_FAIL";
export const RESTORE_KMS_DOCUMENT_FROM_TRASH_REQUEST = "RESTORE_KMS_DOCUMENT_FROM_TRASH_REQUEST";
export const RESTORE_KMS_DOCUMENT_FROM_TRASH_SUCCESS = "RESTORE_KMS_DOCUMENT_FROM_TRASH_SUCCESS";
export const RESTORE_KMS_DOCUMENT_FROM_TRASH_FAIL = "RESTORE_KMS_DOCUMENT_FROM_TRASH_FAIL";
export const HARD_DELETE_KMS_DOCUMENT_REQUEST = "HARD_DELETE_KMS_DOCUMENT_REQUEST";
export const HARD_DELETE_KMS_DOCUMENT_SUCCESS = "HARD_DELETE_KMS_DOCUMENT_SUCCESS";
export const HARD_DELETE_KMS_DOCUMENT_FAIL = "HARD_DELETE_KMS_DOCUMENT_FAIL";

export const SET_KMS_DOCUMENT_LIST_LOADING = "SET_KMS_DOCUMENT_LIST_LOADING";
export const SET_KMS_DOCUMENT_DETAIL_LOADING = "SET_KMS_DOCUMENT_DETAIL_LOADING";
export const SET_KMS_DOCUMENT_SAVE_LOADING = "SET_KMS_DOCUMENT_SAVE_LOADING";
export const CLEAR_KMS_DOCUMENT_MESSAGE = "CLEAR_KMS_DOCUMENT_MESSAGE";
export const CLEAR_KMS_DOCUMENT_ERROR = "CLEAR_KMS_DOCUMENT_ERROR";

export const getKmsDocumentsByRepertoireRequest = (repertoireId) => ({
    type: GET_KMS_DOCUMENTS_BY_REPERTOIRE_REQUEST,
    payload: { repertoireId },
});

export const getKmsDocumentsRequest = (filters = {}) => ({
    type: GET_KMS_DOCUMENTS_REQUEST,
    payload: filters,
});

export const getKmsArchivedDocumentsRequest = () => ({
    type: GET_KMS_ARCHIVED_DOCUMENTS_REQUEST,
});

export const getKmsArchivedDocumentsSuccess = (items) => ({
    type: GET_KMS_ARCHIVED_DOCUMENTS_SUCCESS,
    payload: items,
});

export const getKmsArchivedDocumentsFail = (error) => ({
    type: GET_KMS_ARCHIVED_DOCUMENTS_FAIL,
    error,
});

export const getKmsTrashedDocumentsRequest = () => ({
    type: GET_KMS_TRASHED_DOCUMENTS_REQUEST,
});

export const getKmsTrashedDocumentsSuccess = (items) => ({
    type: GET_KMS_TRASHED_DOCUMENTS_SUCCESS,
    payload: items,
});

export const getKmsTrashedDocumentsFail = (error) => ({
    type: GET_KMS_TRASHED_DOCUMENTS_FAIL,
    error,
});

export const getKmsDocumentsSuccess = (items, filters = {}) => ({
    type: GET_KMS_DOCUMENTS_SUCCESS,
    payload: { items, filters },
});

export const getKmsDocumentsFail = (error) => ({
    type: GET_KMS_DOCUMENTS_FAIL,
    error,
});

export const getKmsDocumentsByRepertoireSuccess = (repertoireId, items) => ({
    type: GET_KMS_DOCUMENTS_BY_REPERTOIRE_SUCCESS,
    payload: { repertoireId, items },
});

export const getKmsDocumentsByRepertoireFail = (error) => ({
    type: GET_KMS_DOCUMENTS_BY_REPERTOIRE_FAIL,
    error,
});

export const getKmsDocumentsByContentRequest = (contentId) => ({
    type: GET_KMS_DOCUMENTS_BY_CONTENT_REQUEST,
    payload: { contentId },
});

export const getKmsDocumentsByContentSuccess = (contentId, items) => ({
    type: GET_KMS_DOCUMENTS_BY_CONTENT_SUCCESS,
    payload: { contentId, items },
});

export const getKmsDocumentsByContentFail = (error) => ({
    type: GET_KMS_DOCUMENTS_BY_CONTENT_FAIL,
    error,
});

export const getKmsDocumentRequest = (documentId) => ({
    type: GET_KMS_DOCUMENT_REQUEST,
    payload: { documentId },
});

export const getKmsDocumentSuccess = (document) => ({
    type: GET_KMS_DOCUMENT_SUCCESS,
    payload: document,
});

export const getKmsDocumentFail = (error) => ({
    type: GET_KMS_DOCUMENT_FAIL,
    error,
});

export const uploadKmsDocumentToRepertoireRequest = (repertoireId, payload) => ({
    type: UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_REQUEST,
    payload: { repertoireId, payload },
});

export const uploadKmsDocumentToRepertoireSuccess = (document) => ({
    type: UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_SUCCESS,
    payload: document,
});

export const uploadKmsDocumentToRepertoireFail = (error) => ({
    type: UPLOAD_KMS_DOCUMENT_TO_REPERTOIRE_FAIL,
    error,
});

export const uploadKmsDocumentToContentRequest = (contentId, payload) => ({
    type: UPLOAD_KMS_DOCUMENT_TO_CONTENT_REQUEST,
    payload: { contentId, payload },
});

export const uploadKmsDocumentToContentSuccess = (document) => ({
    type: UPLOAD_KMS_DOCUMENT_TO_CONTENT_SUCCESS,
    payload: document,
});

export const uploadKmsDocumentToContentFail = (error) => ({
    type: UPLOAD_KMS_DOCUMENT_TO_CONTENT_FAIL,
    error,
});

export const updateKmsDocumentRequest = (documentId, payload) => ({
    type: UPDATE_KMS_DOCUMENT_REQUEST,
    payload: { documentId, payload },
});

export const updateKmsDocumentSuccess = (document) => ({
    type: UPDATE_KMS_DOCUMENT_SUCCESS,
    payload: document,
});

export const updateKmsDocumentFail = (error) => ({
    type: UPDATE_KMS_DOCUMENT_FAIL,
    error,
});

export const changeKmsDocumentStatusSuccess = (document) => ({
    type: CHANGE_KMS_DOCUMENT_STATUS_SUCCESS,
    payload: document,
});

export const changeKmsDocumentStatusFail = (error) => ({
    type: CHANGE_KMS_DOCUMENT_STATUS_FAIL,
    error,
});

export const submitKmsDocumentRequest = (documentId, comment = "") => ({
    type: SUBMIT_KMS_DOCUMENT_REQUEST,
    payload: { documentId, comment },
});

export const approveKmsDocumentRequest = (documentId, comment = "") => ({
    type: APPROVE_KMS_DOCUMENT_REQUEST,
    payload: { documentId, comment },
});

export const rejectKmsDocumentRequest = (documentId, comment = "") => ({
    type: REJECT_KMS_DOCUMENT_REQUEST,
    payload: { documentId, comment },
});

export const returnKmsDocumentToDraftRequest = (documentId, comment = "") => ({
    type: RETURN_KMS_DOCUMENT_TO_DRAFT_REQUEST,
    payload: { documentId, comment },
});

export const publishKmsDocumentRequest = (documentId, comment = "") => ({
    type: PUBLISH_KMS_DOCUMENT_REQUEST,
    payload: { documentId, comment },
});

export const archiveKmsDocumentRequest = (documentId, repertoireId = null, contentId = null) => ({
    type: ARCHIVE_KMS_DOCUMENT_REQUEST,
    payload: { documentId, repertoireId, contentId },
});

export const archiveKmsDocumentFail = (error) => ({
    type: ARCHIVE_KMS_DOCUMENT_FAIL,
    error,
});

export const getKmsDocumentCommentsRequest = (documentId) => ({
    type: GET_KMS_DOCUMENT_COMMENTS_REQUEST,
    payload: { documentId },
});

export const getKmsDocumentSubscriptionRequest = (documentId) => ({
    type: GET_KMS_DOCUMENT_SUBSCRIPTION_REQUEST,
    payload: { documentId },
});

export const getKmsDocumentRatingSummaryRequest = (documentId) => ({
    type: GET_KMS_DOCUMENT_RATING_SUMMARY_REQUEST,
    payload: { documentId },
});

export const getKmsDocumentCommentsSuccess = (documentId, items) => ({
    type: GET_KMS_DOCUMENT_COMMENTS_SUCCESS,
    payload: { documentId, items },
});

export const getKmsDocumentSubscriptionSuccess = (documentId, subscription) => ({
    type: GET_KMS_DOCUMENT_SUBSCRIPTION_SUCCESS,
    payload: { documentId, subscription },
});

export const getKmsDocumentRatingSummarySuccess = (documentId, summary) => ({
    type: GET_KMS_DOCUMENT_RATING_SUMMARY_SUCCESS,
    payload: { documentId, summary },
});

export const getKmsDocumentCommentsFail = (documentId, error) => ({
    type: GET_KMS_DOCUMENT_COMMENTS_FAIL,
    payload: { documentId },
    error,
});

export const getKmsDocumentSubscriptionFail = (documentId, error) => ({
    type: GET_KMS_DOCUMENT_SUBSCRIPTION_FAIL,
    payload: { documentId },
    error,
});

export const getKmsDocumentRatingSummaryFail = (documentId, error) => ({
    type: GET_KMS_DOCUMENT_RATING_SUMMARY_FAIL,
    payload: { documentId },
    error,
});

export const createKmsDocumentCommentRequest = (documentId, message) => ({
    type: CREATE_KMS_DOCUMENT_COMMENT_REQUEST,
    payload: { documentId, message },
});

export const upsertKmsDocumentRatingRequest = (documentId, rating) => ({
    type: UPSERT_KMS_DOCUMENT_RATING_REQUEST,
    payload: { documentId, rating },
});

export const createKmsDocumentCommentSuccess = (documentId) => ({
    type: CREATE_KMS_DOCUMENT_COMMENT_SUCCESS,
    payload: { documentId },
});

export const upsertKmsDocumentRatingSuccess = (documentId, summary = null) => ({
    type: UPSERT_KMS_DOCUMENT_RATING_SUCCESS,
    payload: { documentId, summary },
});

export const createKmsDocumentCommentFail = (documentId, error) => ({
    type: CREATE_KMS_DOCUMENT_COMMENT_FAIL,
    payload: { documentId },
    error,
});

export const upsertKmsDocumentRatingFail = (documentId, error) => ({
    type: UPSERT_KMS_DOCUMENT_RATING_FAIL,
    payload: { documentId },
    error,
});

export const deleteKmsDocumentCommentRequest = (documentId, commentId) => ({
    type: DELETE_KMS_DOCUMENT_COMMENT_REQUEST,
    payload: { documentId, commentId },
});

export const subscribeKmsDocumentRequest = (documentId) => ({
    type: SUBSCRIBE_KMS_DOCUMENT_REQUEST,
    payload: { documentId },
});

export const unsubscribeKmsDocumentRequest = (documentId) => ({
    type: UNSUBSCRIBE_KMS_DOCUMENT_REQUEST,
    payload: { documentId },
});

export const deleteKmsDocumentCommentSuccess = (documentId) => ({
    type: DELETE_KMS_DOCUMENT_COMMENT_SUCCESS,
    payload: { documentId },
});

export const subscribeKmsDocumentSuccess = (documentId, subscription = null) => ({
    type: SUBSCRIBE_KMS_DOCUMENT_SUCCESS,
    payload: { documentId, subscription },
});

export const unsubscribeKmsDocumentSuccess = (documentId, subscription = null) => ({
    type: UNSUBSCRIBE_KMS_DOCUMENT_SUCCESS,
    payload: { documentId, subscription },
});

export const deleteKmsDocumentCommentFail = (documentId, error) => ({
    type: DELETE_KMS_DOCUMENT_COMMENT_FAIL,
    payload: { documentId },
    error,
});

export const subscribeKmsDocumentFail = (documentId, error) => ({
    type: SUBSCRIBE_KMS_DOCUMENT_FAIL,
    payload: { documentId },
    error,
});

export const unsubscribeKmsDocumentFail = (documentId, error) => ({
    type: UNSUBSCRIBE_KMS_DOCUMENT_FAIL,
    payload: { documentId },
    error,
});

export const deleteKmsDocumentRequest = (documentId, repertoireId = null, contentId = null) => ({
    type: DELETE_KMS_DOCUMENT_REQUEST,
    payload: { documentId, repertoireId, contentId },
});

export const deleteKmsDocumentSuccess = (documentId, repertoireId = null, contentId = null) => ({
    type: DELETE_KMS_DOCUMENT_SUCCESS,
    payload: { documentId, repertoireId, contentId },
});

export const deleteKmsDocumentFail = (error) => ({
    type: DELETE_KMS_DOCUMENT_FAIL,
    error,
});

export const restoreKmsDocumentFromArchiveRequest = (documentId) => ({
    type: RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_REQUEST,
    payload: { documentId },
});

export const restoreKmsDocumentFromArchiveSuccess = (document) => ({
    type: RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_SUCCESS,
    payload: document,
});

export const restoreKmsDocumentFromArchiveFail = (error) => ({
    type: RESTORE_KMS_DOCUMENT_FROM_ARCHIVE_FAIL,
    error,
});

export const restoreKmsDocumentFromTrashRequest = (documentId) => ({
    type: RESTORE_KMS_DOCUMENT_FROM_TRASH_REQUEST,
    payload: { documentId },
});

export const restoreKmsDocumentFromTrashSuccess = (document) => ({
    type: RESTORE_KMS_DOCUMENT_FROM_TRASH_SUCCESS,
    payload: document,
});

export const restoreKmsDocumentFromTrashFail = (error) => ({
    type: RESTORE_KMS_DOCUMENT_FROM_TRASH_FAIL,
    error,
});

export const hardDeleteKmsDocumentRequest = (documentId, source = "trash") => ({
    type: HARD_DELETE_KMS_DOCUMENT_REQUEST,
    payload: { documentId, source },
});

export const hardDeleteKmsDocumentSuccess = (documentId, source = "trash") => ({
    type: HARD_DELETE_KMS_DOCUMENT_SUCCESS,
    payload: { documentId, source },
});

export const hardDeleteKmsDocumentFail = (error) => ({
    type: HARD_DELETE_KMS_DOCUMENT_FAIL,
    error,
});

export const setKmsDocumentListLoading = (loading) => ({
    type: SET_KMS_DOCUMENT_LIST_LOADING,
    payload: loading,
});

export const setKmsDocumentDetailLoading = (loading) => ({
    type: SET_KMS_DOCUMENT_DETAIL_LOADING,
    payload: loading,
});

export const setKmsDocumentSaveLoading = (loading) => ({
    type: SET_KMS_DOCUMENT_SAVE_LOADING,
    payload: loading,
});

export const clearKmsDocumentMessage = () => ({
    type: CLEAR_KMS_DOCUMENT_MESSAGE,
});

export const clearKmsDocumentError = () => ({
    type: CLEAR_KMS_DOCUMENT_ERROR,
});
